import React, { FC } from 'react';
import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  totalElements: number;
  elementsDisplayed: number;
  activeDotIndex: number;
  onClick: (index: number) => void;
}

const ProgressBar: FC<ProgressBarProps> = ({ totalElements, elementsDisplayed, activeDotIndex, onClick }) => {
  const numberOfDots = Math.ceil(totalElements / elementsDisplayed);

  return (
    <div className={styles.progressBar}>
      {Array.from({ length: numberOfDots }, (_, index) => (
        <span
          onClick={() => onClick(index)}
          key={index}
          className={index === activeDotIndex ? styles.activeDot : styles.inactiveDot}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
